import formatIntegerBySpace from '../../../../helpers/formatters/format-integer-by-space'
import Copies from '../../components/calculation-form/components/form-items/copies'
import isCalculation from '../../helpers/is-calculation'
import type { CalculationColumn } from '../../types/column-types'

export const copiesColumn: CalculationColumn = {
    dataIndex: 'copies',
    title: 'Тираж',
    width: 70,
    editable: true,
    FormItem: <Copies />,
    render: formatIntegerBySpace,
    onCell: record => {
        if (isCalculation(record)) {
            return {
                colSpan: 0,
                editable: false,
            }
        } else {
            return { colSpan: 1, editable: true }
        }
    },
}
